// Editing values stay raw; only calculations and API payloads use numbers.
export const optionalQuoteNumber = (value) => {
  if (value == null || (typeof value === "string" && value.trim() === "")) return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};
export const safeNumber = (value) => optionalQuoteNumber(value) ?? 0;
export const lineTotal = (it) => safeNumber(safeNumber(it.qty) * safeNumber(it.unit_price) *
  (1 - Math.min(100, Math.max(0, safeNumber(it.discount_pct))) / 100));
export const normalizeQuoteItems = (items = []) => (items || []).map((it) => ({
  ...it, qty: safeNumber(it.qty), unit_price: optionalQuoteNumber(it.unit_price),
  discount_pct: safeNumber(it.discount_pct),
  labour_cost: optionalQuoteNumber(it.labour_cost),
  material_cost: optionalQuoteNumber(it.material_cost),
  plant_cost: optionalQuoteNumber(it.plant_cost),
}));
export const quotePriceError = (items = []) => {
  const item = (items || []).find((it) => !it.is_section && optionalQuoteNumber(it.unit_price) === null);
  return item ? `PRICE REQUIRED: ${item.description || "This line item"} requires a unit price before this quote can be sent or previewed.` : null;
};
